import { createSlice } from "@reduxjs/toolkit";

const initialState = {};
const EventReducer = createSlice({
  name: "Event",
  initialState,
  reducers: {
    defaultAction: (state, { payload }) => {
      console.log("EventReducer state and payload", state, payload);
    },
  },
});

const { reducer, actions } = EventReducer;
export const { defaultAction } = actions;
export default reducer;
